import { useLocation } from "react-router-dom";

export function useCurrentView() {
  const location = useLocation();

  if (location.pathname.includes("mentees")) {
    return {
      id: "mentees",
      label: "My Mentees",
      description: "Manage your mentees",
    };
  }
  if (location.pathname.includes("appointments")) {
    return {
      id: "sessions",
      label: "Sessions",
      description: "Manage your sessions",
    };
  }
  if (location.pathname.includes("analytics")) {
    return {
      id: "analytics",
      label: "Analytics",
      description: "View your analytics and performance",
    };
  }
  if (location.pathname.includes("resources")) {
    return {
      id: "resources",
      label: "Resources",
      description: "View your resources and materials",
    };
  }
  if (location.pathname.includes("messages")) {
    return {
      id: "messages",
      label: "Messages",
      description: "View your messages and notifications",
    };
  }
  if (location.pathname.includes("pre-session")) {
    return {
      id: "pre-session",
      label: "Pre-Session Information",
      description: "Review mentee details before starting your session",
    };
  }

  return {
    id: "dashboard",
    label: "Dashboard",
    description: "View your mentees and coaching sessions",
  };
}
